import { PayPanel } from '@/features/pay'

export default function Pay() {
  return (
    <div className='w-100vw h-100vh bg-bg_2 flex justify-center pt-150px'>
      <PayPanel />
    </div>
  )
}
